/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

export const ai_boost_google_ad_group: StateInterface["ai_boost_google_ad_group"] = {
	_id: "",
	boost_id: "",
	property_id: "",
	campaign_resource_name: "",
	ad_group_resource_name: "",
	ad_group_name: "",
	ad_group_type: "",
	start_date: "",
	end_date: "",
	ad_group_criterion_resource_names: [],
	daily_budget: 0,
	status: "",
	keywords: [],
	negative_keywords: [],
	similar_website_urls: [],
	deleted: false,
	deleted_at: "",
	created_at: "",
	updated_at: "",
	last_optimized_at: "",
	last_optimization_action: "",
	last_optimization_remarks: "",
};

export default ai_boost_google_ad_group;
